import styled from "styled-components";

const theme = {
  bg: '#121212',
  surface: '#1E1E1E',
  surfaceHover: '#2A2A2A',
  gold: '#D4AF37',
  text: '#FFFFFF',
  textSecondary: '#A9A9A9',
  border: '#333333',
  positivo: '#50fa7b', // Verde para valores positivos
  negativo: '#ff5555', // Vermelho para valores negativos
};

export const SearchBarContainer = styled.div`
    width: 100%;
    max-width: 500px;
    position: relative;
    margin-bottom: 1.5rem;
    
    svg {
        position: absolute;
        left: 1rem;
        top: 50%;
        transform: translateY(-50%);
        color: ${theme.textSecondary};
    }

    input {
        width: 100%;
        height: 45px;
        box-sizing: border-box;
        background-color: ${theme.bg};
        border: 1px solid ${theme.border};
        border-radius: 8px;
        color: ${theme.text};
        font-size: 1rem;
        padding: 0 1rem 0 3rem; /* Espaço para o ícone */
        outline: none;
        transition: border-color 0.2s ease;

        &:focus {
            border-color: ${theme.gold};
        }
    }
`;

export const TabelaWrapper = styled.div`
    width: 100%;
    overflow-x: auto; /* MÁGICA DA RESPONSIVIDADE! */
    border: 1px solid ${theme.border};
    border-radius: 12px;

    &::-webkit-scrollbar { height: 8px; }
    &::-webkit-scrollbar-track { background: ${theme.bg}; border-radius: 10px; }
    &::-webkit-scrollbar-thumb { background-color: ${theme.gold}; border-radius: 10px; }
`;

export const Table = styled.table`
    width: 100%;
    min-width: 700px; /* Garante que a tabela tenha espaço, forçando o scroll no mobile */
    border-collapse: collapse;
    color: ${theme.text};
    font-size: 0.9rem;

    th, td {
        padding: 1rem 1.5rem;
        text-align: left;
        border-bottom: 1px solid ${theme.border};
        white-space: nowrap; /* Impede que o texto quebre linha */
    }

    th {
        background-color: rgba(0, 0, 0, 0.2);
        font-weight: 600;
        color: ${theme.textSecondary};
        text-transform: uppercase;
        font-size: 0.8rem;
    }

    tbody tr {
        transition: background-color 0.2s ease;
        &:hover {
            background-color: ${theme.surfaceHover};
        }
    }
    
    tbody td[colspan="4"] {
        text-align: center;
        padding: 3rem;
        color: ${theme.textSecondary};
    }

    .value-cell {
        font-weight: 700;
        &.positivo {
            color: ${theme.positivo};
        }
        &.negativo {
            color: ${theme.negativo};
        }
    }
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2rem;
    gap: 0.5rem;
    flex-wrap: wrap;
`;

export const PaginationButton = styled.button`
    height: 40px;
    width: 40px;
    background-color: ${theme.border};
    color: ${theme.text};
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;

    &:hover:not(:disabled) {
        background-color: ${theme.gold};
        color: ${theme.surface};
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
`;

export const PageInfo = styled.span`
    margin: 0 1rem;
    color: ${theme.textSecondary};
    font-size: 0.9rem;
`;